var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"scrolltop",attrs:{"type":"button","data-aos":"zoom-in","data-aos-once":"false","data-aos-id":"scrolltop","data-aos-offset":"400","title":"Revenir en haut"},on:{"click":_vm.ScrollTo}},[_c('span',[_vm._v("☝️")])])}
var staticRenderFns = []

export { render, staticRenderFns }